export default __webpack_public_path__ + "static/media/decor5.733e2f0c.webp";